import { Box, SxProps, Theme } from "@mui/material"
import React from "react"

interface IFlexBoxProps {
  id?: string
  vertical?: boolean // flex-direction: column
  ai?: string // align-items
  jc?: string // justify-content
  sx?: SxProps<Theme>
  fullWidth?: boolean
  fullHeight?: boolean | string // string => `calc(100% - ${fullHeight})`
  wrap?: boolean
  gap?: boolean | string
  className?: string
  onClick?: (event: any) => any
  onDoubleClick?: (event: MouseEvent) => any
}

export class FlexBox extends React.PureComponent<IFlexBoxProps, {}> {
  public render() {
    const height = this.getHeight()
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: this.props.vertical ? "column" : undefined,
          alignItems: this.props.ai ? this.props.ai : "center",
          justifyContent: this.props.jc ? this.props.jc : "center",
          width: this.props.fullWidth ? "100%" : undefined,
          gap: typeof this.props.gap === "string" ? this.props.gap : this.props.gap ? "1rem" : undefined,
          flexWrap: this.props.wrap ? "wrap" : undefined,
          height,
          minHeight: height,
          maxHeight: height,
          ...this.props.sx
        }}
        id={this.props.id}
        className={this.props.className}
        onClick={event => (this.props.onClick ? this.props.onClick(event as any) : undefined)}
        onDoubleClick={event => (this.props.onDoubleClick ? this.props.onDoubleClick(event as any) : undefined)}>
        {this.props.children}
      </Box>
    )
  }

  private getHeight(): string | undefined {
    if (!this.props.fullHeight) {
      return undefined
    }
    if (this.props.fullHeight === true) {
      return "100%"
    }
    return `calc(100% - ${this.props.fullHeight})`
  }
}
